<template>
	<div class="card md-elevation-4" style="width: 100%; height: 100%; overflow-x: auto; overflow-y: hidden">
		<div style="padding: 5px; display: flex">
			<el-tooltip>
				<div slot="content">
					<span>{{ $t("compilations-overview-description") }}</span>
				</div>
				<span class="tab title">{{ $t("compilations-overview") }}</span>
			</el-tooltip>

			<div style="margin-top: auto; margin-bottom: auto; display: flex; margin-left: auto; margin-right: 0">
				<div :style="{ display: isMobile ? 'block' : 'flex' }">
					<el-select v-model="filter.from_month" style="width: 125px" @change="searchable = true">
						<el-option
							v-for="(month, index) in MONTHS"
							:key="index"
							:disabled="filter.from_year == filter.to_year && index > MONTHS.indexOf(filter.to_month)"
							:label="month"
							:value="month"
						/>
					</el-select>
					<el-select v-model="filter.from_year" style="width: 85px" @change="searchable = true">
						<el-option
							v-for="(year, index) in YEARS"
							:key="index"
							:disable="year > filter.to_year"
							:label="year"
							:value="year"
						/>
					</el-select>
				</div>
				<div :style="{ display: isMobile ? 'block' : 'flex' }">
					<el-select v-model="filter.to_month" style="width: 125px" @change="searchable = true">
						<el-option
							v-for="(month, index) in MONTHS"
							:key="index"
							:disabled="filter.from_year == filter.to_year && index <= MONTHS.indexOf(filter.from_month)"
							:label="month"
							:value="month"
						/>
					</el-select>
					<el-select v-model="filter.to_year" style="width: 85px" @change="searchable = true">
						<el-option
							v-for="(year, index) in YEARS"
							:key="index"
							:disabled="year < filter.from_year"
							:label="year"
							:value="year"
						/>
					</el-select>
				</div>
				<md-button v-if="searchable" class="md-icon-button" @click="() => handleSearch()">
					<md-icon>search</md-icon>
				</md-button>
			</div>
		</div>
		<div style="width: 100%">
			<apexchart
				type="bar"
				height="350"
				ref="charts"
				:style="{ width: 'auto' }"
				:options="chartOptions"
				:series="series"
			></apexchart>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"

import axios from "axios"
import { months } from "moment"
export default {
	name: "compilations-chart",
	data() {
		return {
			filter: {
				from_month: undefined,
				from_year: undefined,
				to_month: undefined,
				to_year: undefined
			},
			searchable: false,
			categories: [],
			array_categories: [],

			width: window.innerWidth - 550,

			// BAR CHARTS
			series: [
				// {
				// 	name: this.$t("procedures"),
				// 	url_ref: "/api/projects/getAllFolders",
				// 	data: []
				// },
				{
					name: this.$t("projects"),
					url_ref: "/api/projects/getAll",
					data: []
				},
				{
					name: this.$t("documents"),
					url_ref: "/api/documents/getalladmin",
					data: []
				}
			],
			chartOptions: {
				chart: {
					type: "bar"
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: "55%",
						endingShape: "rounded"
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"]
				},
				xaxis: {
					categories: []
				},
				fill: {
					opacity: 1
				}
			}
		}
	},

	computed: {
		...mapGetters({
			MONTHS: "dashboard/months",
			YEARS: "dashboard/years"
		}),
		isMobile: function () {
			return window.innerWidth < 800
		}
	},
	mounted() {
		this.filter = {
			from_month: this.MONTHS[new Date().getMonth()],
			to_month: this.MONTHS[new Date().getMonth()],
			from_year: new Date().getFullYear() - 1,
			to_year: new Date().getFullYear()
		}
		this.setCategories()
		this.setSeries()
	},

	methods: {
		handleSearch: function () {
			this.searchable = false
			this.setCategories()
			var payload = {
				to_year: this.filter.to_year + "",
				from_year: this.filter.from_year + "",
				from_month: this.MONTHS.indexOf(this.filter.from_month),
				to_month: this.MONTHS.indexOf(this.filter.to_month)
			}
			this.setSeries()
		},

		setCategories: function () {
			this.array_categories = {}
			var diff_year = this.filter.to_year - this.filter.from_year
			var diff_month = diff_year * 12 + (diff_year > 0 ? 1 : 0)
			diff_month -= this.MONTHS.indexOf(this.filter.from_month) - this.MONTHS.indexOf(this.filter.to_month)

			var categories = []
			var shift = this.MONTHS.indexOf(this.filter.from_month)
			let index = 0
			for (var i = shift; i < diff_month + shift; i++) {
				var j = i > 12 ? (i % 12) - 1 : i % 12
				let year = this.filter.from_year + parseInt(i / 12)
				categories.push(this.MONTHS[j] + "-" + year)

				this.array_categories[year + "-" + j] = index
				index++
			}
			this.$refs.charts.updateOptions({ labels: categories }, true, true, true)

			this.categories = categories
		},
		setSeries: async function () {
			var data = []
			for (let i = 0; i < this.series.length; i++) {
				let series = []

				data = await this.retrieveFromApi(this.series[i].url_ref)

				this.series[i].data = data
			}

			this.$refs.charts.updateSeries(this.series, true, true, true)
		},

		async retrieveFromApi(urlref) {
			var toreturn = Array(this.array_categories.length).fill(0)
			const payload = {
				pagination: {},
				search: "",
				organization_id: 0
			}
			return await axios
				.post(`${process.env.VUE_APP_API_URL}${urlref}`, payload, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(async res => {
					res.data.items.forEach(element => {
						let month = new Date(element.created_at).getUTCMonth()
						let year = new Date(element.created_at).getFullYear()
						let index = this.array_categories[year + "-" + month]
						if (index != undefined) {
							if (toreturn[index] === undefined) {
								toreturn[index] = 0
							}

							toreturn[index]++
						}
					})

					return toreturn
				})
				.catch(() => {})
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";
.tab {
	font-size: 24px;
	margin-top: auto;
	margin-bottom: auto;
	&:hover {
		cursor: pointer;
	}
	margin-left: 5px;
	margin-right: 5px;
}
.title {
	font-weight: 900;
}
.demo {
	position: absolute;
	top: 0;
	z-index: 0;
	width: 100%;
	height: 100%;
}
</style>
